import type { ReactNode } from "react";

export enum CategorySelectionState {
    EMPTY = 0,
    PARTIAL = 1,
    FULL = 2,
}

export interface ICategory {
    id: string;
    icon?: string;
    name?: string;
    count?: number;
    isChild?: boolean;
    parentId?: string;
    sons?: ICategory[];
    isCustomCategory?: boolean;
    selected?: CategorySelectionState;
    disabled?: boolean;
}

export interface IMultiCategoriesChipDownProps {
    initialSelectedCategories: string[];
    categories: ICategory[];
    onDone: (selectedCategories: FixmeType) => void;
    buttonText: string;
    searchPlaceholder: string;
    dropdownComponent?: ReactNode;
    ignoreParentOnSelect?: boolean;
    maxSelectedCategories?: number;
    disableChildrenOnParentSelect?: boolean;
}
